import React from 'react'
import { Form, Button, Message, Input, Segment, Header } from 'semantic-ui-react'

export default class FormLogin extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            username: '',
            isPlaying: false,
        }
    }

    handleRef = component => this.userNameField = component

    componentDidMount() {
        //this.userNameField.focus()
    }

    login() {
        const {username } = this.state
        this.props.onLogin({username })
    }

    onSubmit = (e) => {
        this.login()
        return false
    }

    handleFormClick = () => {
        if (this.state.isPlaying)
            return
        this.setState({ isPlaying: true })
    }

    onNameChange = (e) => this.setState({ username: e.target.value })

    render() {
        const { error, loading } = this.props
        const {  username} = this.state
        
        return (
            <Form onSubmit={this.onSubmit} loading={loading} onClick={this.handleFormClick}>
                <Header as='h2'>{'Entra'}</Header>
                {error ? <Message negative><p>{error}</p></Message> : ''}
                         <body>
                            <Segment>
                            <Form.Field>
                                <Input ref={this.handleRef} name='username' value={username} onChange={this.onNameChange} 
                                placeholder={ 'Inserisci il tuo nome '} icon='at' iconPosition='left' />
                                </Form.Field>
                                <Button fluid primary  type="submit">{'Accedi'}</Button>
                            </Segment>
                            </body>
            </Form>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/FormLogin.js